import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-address-create-confirmation-modal",
  templateUrl: "./address-create-confirmation-modal.component.html",
})
export class CreateAddressConfirmationModalComponent {
  @Input() visible = false;
  @Input() addressId?: string;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  onConfirm(): void {
    this.confirm.emit();
    this.close();
  }

  onCancel(): void {
    this.cancel.emit();
    this.close();
  }

  private close(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }
}
